import DateRangeSelector from "pages/dashboard-overview/components/DateRangeSelector";
import useHttp from "hooks/useHttp";
import useAnalyticsFilters from "hooks/useAnalyticsFilters";
import FinanceKpiCards from "pages/analytics/finance/components/FinanceKpiCards";
import SubscriptionKpiCards from "pages/analytics/finance/components/SubscriptionKpiCards";
import ProfitLossSummary from "pages/analytics/finance/components/ProfitLossSummary";
import RevenueExpenseProfitTrendChart from "pages/analytics/finance/components/RevenueExpenseProfitTrendChart";
import ProductBreakdownSection from "pages/analytics/finance/components/ProductBreakdownSection";
import StripeReconciliationPanel from "pages/analytics/finance/components/StripeReconciliationPanel";

export default function FinanceDashboard() {
  const api = useHttp();
  const { filters, dateRange, setDateRange, customRange, setCustomRange } =
    useAnalyticsFilters("thisMonth");

  return (
    <>
      <div className="mb-4 flex flex-col gap-4 sm:flex-row sm:justify-between">
        <DateRangeSelector
          selected={dateRange}
          onChange={setDateRange}
          customRange={customRange}
          onCustomRangeChange={setCustomRange}
        />
      </div>

      <div id="overview" className="scroll-mt-4">
        <FinanceKpiCards api={api} filters={filters} />
        <SubscriptionKpiCards api={api} filters={filters} />
      </div>
      <ProfitLossSummary api={api} filters={filters} />
      <RevenueExpenseProfitTrendChart api={api} filters={filters} />
      <ProductBreakdownSection api={api} filters={filters} />
      <StripeReconciliationPanel api={api} />
    </>
  );
}
